import { useSelector } from 'react-redux';

export const useSeatIdIsSetOnCart = () => {
  const cart = useSelector(state => state.cart);
  return !!cart.seating_identifier_value;
};
